/**
 * base_url     接口请求地址
 * img_upload   图片上传地址
 * bosh_service strophe http-bind
 * */

let base_url, comein_url, img_upload, bosh_service, esign_url;
let market_url,
	share_url,
	purchase_url,
	performance_url,
	trade_detail_url,
	trade_total_url,
	irm_url,
	fileViewerUrl,
	aliyunProjectName,
	logstore,
	irstoreLogstore,
	comeinPCImageUrl;

import { isBuild } from '@/utils/const';

// 环境区分
if (isBuild) {
	base_url = 'https://server.comein.cn/comein/index.php';
	comein_url = 'https://server.comein.cn/comein';
	esign_url = 'https://e-sign.comein.cn';
	img_upload = 'https://server.comein.cn/comein/image.upload';
	bosh_service = 'https://im.comein.cn:7443/http-bind/';
	irm_url = 'https://server.comein.cn/comein/irmcenter';
	fileViewerUrl = 'https://mobile.comein.cn/onlinePreview/onlinePreview?url=';

	/* HS接口 生产 */
	market_url = 'https://open.hscloud.cn/quote/v1/real';
	share_url = 'https://open.hscloud.cn/info/v3/new_share_info';
	purchase_url = 'https://open.hscloud.cn/info/v3/purchase_carried_out';
	performance_url = 'https://open.hscloud.cn/info/v3/new_share_performance';
	trade_detail_url = 'https://open.hscloud.cn/info/v3/margin_trade_detail';
	trade_total_url = 'https://open.hscloud.cn/info/v3/margin_trade_total';
	aliyunProjectName = 'irm-pro';
	logstore = 'irm-monitor-pro';
	irstoreLogstore = 'irm-external-pro';
	comeinPCImageUrl = 'https://image.comein.cn/comein-files';
} else {

	base_url = 'https://testserver.comein.cn/comein/index.php';
	comein_url = 'https://testserver.comein.cn/comein';
	esign_url = 'https://e-sign-test.comein.cn';
	img_upload = 'https://testserver.comein.cn/comein/image.upload';
	// bosh_service = 'https://testserver.comein.cn:7443/http-bind/';
	bosh_service = 'https://imtest.comein.cn:7443/http-bind/';
	irm_url = 'https://testserver.comein.cn/comein/irmcenter';
	fileViewerUrl = 'https://testmobile.comein.cn/onlinePreview/onlinePreview?url=';

	/* HS接口 生产 */
	market_url = 'https://open.hscloud.cn/quote/v1/real';
	share_url = 'https://open.hscloud.cn/info/v3/new_share_info';
	purchase_url = 'https://open.hscloud.cn/info/v3/purchase_carried_out';
	performance_url = 'https://open.hscloud.cn/info/v3/new_share_performance';
	trade_detail_url = 'https://open.hscloud.cn/info/v3/margin_trade_detail';
	trade_total_url = 'https://open.hscloud.cn/info/v3/margin_trade_total';
	aliyunProjectName = 'irm';
	logstore = 'irm-monitor';
	irstoreLogstore = 'irm-external';
	comeinPCImageUrl = 'https://testimage.comein.cn/comein-files';
}

let comeinStaticCDN = 'https://image.comein.cn/web/irm';

export const BASEURL = base_url;
export const COMEINURL = comein_url;
export const IMGUPLOAD = img_upload;
export const BOSH_SERVICE = bosh_service;

export const HSMARKETURL = market_url;
export const HSSHAREURL = share_url;
export const HSPURCHASEURL = purchase_url;
export const HSPERFORMANCEURL = performance_url;
export const HSREADEDETAILURL = trade_detail_url;
export const HSTRADETOTALURL = trade_total_url;
export const IRMURL = irm_url;
export const ESIGN_URL = esign_url;
export const FILE_VIEWER_URL = fileViewerUrl;

export const ALIYUN_PROJECT_NAME = aliyunProjectName;
export const ALIYUN_LOG_STORE = logstore;
export const ALIYUN_IR_LOG_STORE = irstoreLogstore;

export const COMEINPCIMAGE_URL = comeinPCImageUrl;

export const COMEIN_STATIC_CDN = comeinStaticCDN;
